"use strict";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
exports.__esModule = true;
exports.default = void 0;
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var Alert = /*#__PURE__*/ function() {
    function Alert() {
        _class_call_check(this, Alert);
    }
    _create_class(Alert, null, [
        {
            key: "alert",
            value: function alert() {}
        }
    ]);
    return Alert;
}();
var _default = Alert;
exports.default = _default;
module.exports = exports.default;
